export function toggleClass(target) {
  if (target.classList.contains('is-open')) {
    target.classList.remove('is-open');
  } else {
    target.classList.add('is-open');
  }
}
